import { render, staticRenderFns } from "./create-order-page.html?vue&type=template&id=e7e9312e&"
import script from "./create-order-page.ts?vue&type=script&lang=ts&"
export * from "./create-order-page.ts?vue&type=script&lang=ts&"
import style0 from "./create-order-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports